import React from "react";

export default function HelperContent(props){
  const {
    content = ""
  } = props;
  return (
    <div dangerouslySetInnerHTML={{ __html: content }}>
    </div>
  )
}